import { gql, useMutation } from "@apollo/client";

const UPDATE_MOOD_BOARD = gql`
  mutation UpdateDesignBoard(
    $_id: ID!
    $designerId: ID!
    $name: String
    $type: DesignBoardType
    $description: String
    $why: String
    $color: [ColorFamily]
    $texture: [Textures]
    $finish: [Finishes]
    $pattern: [Patterns]
    $roomType: [ProjectCategory]
    $greatFor: GreatFor
    $images: [ID]
    $displayOrder: Int
    $featuredOnBio: Boolean
    $published: Boolean
  ) {
    updateDesignBoard(
      _id: $_id
      designerId: $designerId
      name: $name
      type: $type
      description: $description
      why: $why
      color: $color
      texture: $texture
      finish: $finish
      pattern: $pattern
      roomType: $roomType
      greatFor: $greatFor
      images: $images
      displayOrder: $displayOrder
      featuredOnBio: $featuredOnBio
      published: $published
    ) {
      _id
      color
      description
      designerId
      finish
      greatFor
      images
      name
      pattern
      roomType
      texture
      type
      why
      displayOrder
      featuredOnBio
      published
    }
  }
`;

export const useUpdateMoodBoardMutation = () => {
  const [updateMoodBoardMutation, { loading, error, data }] =
    useMutation(UPDATE_MOOD_BOARD);

  const updateMoodBoard = async (args: any) => {
    try {
      const { data } = await updateMoodBoardMutation({
        variables: args,
      });
      return data?.updateDesignBoard;
    } catch (error) {
      console.error("Error updating mood board:", error);
      throw error;
    }
  };

  return { updateMoodBoard, loading, error, data };
};
